import { FC, SVGAttributes } from "react";

const PlanetIcon: FC<SVGAttributes<SVGSVGElement>> = ({
  stroke = "#000",
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g id="planet" strokeLinecap="round" strokeLinejoin="round" stroke={stroke}>
      <path
        id="Vector"
        d="M5.73288 4.20703L7.19834 5.41158L7.86376 6.12189C8.38818 6.68171 8.62859 7.45017 8.51669 8.20906C8.39744 9.01785 7.89267 9.71825 7.16313 10.0873L6.15073 10.5993C6.02957 10.6606 5.91614 10.7361 5.81285 10.8242L5.52938 11.0661C5.06329 11.4637 4.94946 12.1384 5.25927 12.667C5.30638 12.7473 5.36224 12.8223 5.42583 12.8904L6.08612 13.5977C6.3702 13.902 6.57793 14.2694 6.69221 14.6697L6.73739 14.8279C6.99456 15.7287 6.69803 16.6966 5.98037 17.2987C5.58776 17.6281 5.31228 18.0757 5.19506 18.5746L5.04925 19.1952M19.5629 5.45909L18.9941 5.78185C18.4833 6.07164 17.9198 6.25665 17.3367 6.32604L17.0602 6.35895C16.0578 6.47822 15.0497 6.18878 14.2633 5.55594C13.7102 5.11082 13.2946 4.51795 13.0649 3.84616L13.0046 3.66978C12.9037 3.375 12.7719 3.09177 12.6112 2.82487L12.1147 2M17.8382 11.803C18.173 12.4454 18.1972 13.2053 17.9042 13.8679L16.9806 15.9527C16.7671 16.4341 16.4582 16.8672 16.0728 17.2261L15.6954 17.5773C15.2808 17.9633 14.7454 18.1939 14.1802 18.2302L13.9484 18.245C13.3075 18.2861 12.6858 18.017 12.2772 17.5216C11.8878 17.0495 11.7359 16.4252 11.8649 15.8269L11.961 15.3816C12.0436 14.9987 12.0481 14.5993 11.9757 14.2142C11.8143 13.3556 12.033 12.4604 12.5779 11.7774L12.6097 11.7376C12.9744 11.2802 13.4607 10.9349 14.0127 10.7411L14.3767 10.6133C14.9092 10.4263 15.4844 10.3967 16.0333 10.5279L16.2795 10.5868C16.9507 10.7473 17.5192 11.191 17.8382 11.803ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="black"
        strokeWidth="1.8"
        strokeMiterlimit="10"
      />
    </g>
  </svg>
);

export { PlanetIcon };
